const Advert = require('./advert');

class AdvertOldTypeTwo extends Advert {
  constructor() {
    super();
    this.data;
    this.ex;
    this.admData;
    this.GD_params;
    this.DOM;
    this.TEXT_TOP_GID = 1335; // id: 1335,836
    this.TEXT_MIDDLE_GID = 1336; // id: 1336,837
    this.TEXT_BOTTOM_GID = 1337; // id: 1337,838

  }

  SetDOM() {
    const content = $('div.article-content').first();
    const adms = this.data.adms[ 0 ];
    const platformId = adms.platformId;
    const adpType = this.data.adpType;
    const adpId = this.data.adpId;
    const admId = adms.admId;
    const admHighSpeed = adms.highSpeed;
    const gameId = adms.gameId;
    const url = adms.url;
    const imgUrl = adms.imageSrc;
    $.ajax({
      url: '/tpl/android_new/news/a_adinfo.html',
      type: 'get',
      data: {
        gameId,
        platformId,
        adpId,
        admId,
        admHighSpeed
      },
      dataType: 'html',
      async: false,
      success(html) {
        if (typeof html !== 'undefined' && html !== null && html.trim() !== '') {
          if (this.TEXT_TOP_GID === adpId) {
            const review = $('div.art-review').first();
            if (typeof review !== 'undefined' && review != null && review.length > 0) {
              this.DOM = $(`<div>${html}</div>`);
              $(review).after(this.DOM);
            } else {
              this.DOM = $(`<div>${html}</div>`);
              $(content).prepend(this.DOM);
            }
          } else if (this.TEXT_MIDDLE_GID === adpId) {
            const children = content.children();
            const midChild = children.get(Math.round(children.length / 2 - 1));
            this.DOM = $(`<div>${html}</div>`);
            $(midChild).after(this.DOM);
          } else if (this.TEXT_BOTTOM_GID === adpId) {
            this.DOM = $(`<div>${html}</div>`);
            $(content).append(this.DOM);
          }
          this.SetStateEvent();
        }
      },
      error() {
        console.log('error');
      }
    });
  }
}

module.exports = AdvertOldTypeTwo;


// WEBPACK FOOTER //
// ./lib/js/module/m_advert/module/advert_old_type_two.js